import { Asterisk } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AsteriskIcon = createLucideIcon(Asterisk);
